import { FunctionComponent } from 'react'
import logoConexa from '@/assets/logo-conexa.svg'
import { ClinicLogoProps } from './types'
import { RenderIf } from '../RenderIf'

const ClinicLogo: FunctionComponent<ClinicLogoProps> = ({ uniqueCode }) => {
  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-12 d-flex justify-content-between">
            <RenderIf
              condition={
                !!uniqueCode && uniqueCode.toLocaleLowerCase() !== 'conexa'
              }
            >
              <img
                src={`${process.env.REACT_APP_LINK_LOGO_AWS}${uniqueCode}.png`}
                onError={event => {
                  event.currentTarget.onerror = null
                  event.currentTarget.src = logoConexa
                  event.currentTarget.style.height = 'auto'
                }}
                height={'40px'}
                alt="Conexa Saúde"
              />
            </RenderIf>
            <RenderIf condition={!uniqueCode}>
              <img src={logoConexa} alt="Conexa Saúde" />
            </RenderIf>
          </div>
        </div>
      </div>
    </div>
  )
}

export { ClinicLogo }
